import React from "react";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { useFinancialItem } from "../../contexts/FinancialItemContext";
import AssetsAndDebtsSummary from "./components/AssetsAndDebtsSummary";
import FinanceTasks from "./components/FinanceTasks";

const FinancesIndex: React.FC = () => {
  const { financialItems, loading, error } = useFinancialItem();

  if (loading.list) return <LoadingView title="Loading Custody Events..." />;
  if (error.list) return <ErrorView error={error.list} />;

  return (
    <div className="py-4 space-y-6">
      <AssetsAndDebtsSummary items={financialItems} />
      <FinanceTasks />
    </div>
  );
};

export default FinancesIndex;
